export class ResolutionSwitcher {
	private _wasAutoRendering = false;
	private _upscaleTimer: ReturnType<typeof setTimeout> | undefined;

	constructor(
		private readonly _onDownscale: () => void,
		private readonly _onUpscale: () => void,
		private readonly _debounceMs: number,
	) {}

	update(isAutoRendering: boolean): void {
		if (isAutoRendering && !this._wasAutoRendering) {
			this._clearUpscaleTimer();
			this._onDownscale();
		} else if (!isAutoRendering && this._wasAutoRendering) {
			this._clearUpscaleTimer();
			this._upscaleTimer = setTimeout(() => {
				this._onUpscale();
				this._upscaleTimer = undefined;
			}, this._debounceMs);
		}
		this._wasAutoRendering = isAutoRendering;
	}

	dispose(): void {
		this._clearUpscaleTimer();
	}

	private _clearUpscaleTimer(): void {
		if (this._upscaleTimer !== undefined) {
			clearTimeout(this._upscaleTimer);
			this._upscaleTimer = undefined;
		}
	}
}
